module.exports = __webpack_public_path__ + "assets/images/ending6_5a94ac656e0647fc931e5d6ad8a0adf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending6.png
// module id = 138
// module chunks = 0